import { OrderSample } from './components/OrderSample';
import { usePLPSamples } from './hooks/usePLPSamples';

export { OrderSample, usePLPSamples };
